/**
 * Running phase — template files download from public/templates/.
 */

import { TEMPLATE_FILES, templateHref } from '../templateFile';

export type RunningTemplateLink = {
  label: string;
  href: string;
};

export const RUNNING_CONFIG = {
  /** Update when the named support contact changes. */
  hypercareSupportContact: 'your Innovation Team contact',
} as const;

export const RUNNING_TEMPLATE_LINKS: Record<
  'implementationPlan' | 'milestonePlan' | 'launchCommunication',
  RunningTemplateLink
> = {
  implementationPlan: {
    label: 'Implementation plan.xlsx',
    href: templateHref(TEMPLATE_FILES.implementationPlan),
  },
  milestonePlan: {
    label: 'Milestone Plan.pptx',
    href: templateHref(TEMPLATE_FILES.milestonePlan),
  },
  launchCommunication: {
    label: 'Proof-of-concept launch communication_template.oft',
    href: templateHref(TEMPLATE_FILES.launchCommunication),
  },
};
